<template lang="pug">
    div.cell-content-wrapper
        div.cell-label.l-flex-row.l-align-center
            //- Status
            div.row-item-status(
                :title="fullData.status"
                :class="`item-${fullData.status}`")
            //- Label
            div.css-cut-long-text.row-item-label {{ fullData.label }}
        //- Tags
        div.criterion-tag-list(v-if="fullData.tags && fullData.tags.length > 0 && !selectedAudienceId")
            span.criterion-tag(
                v-for="(tag, tKey) of fullData.tags"
                v-if="showAllTags || tKey < 5"
                :key="tKey"
                :class="{ 'is-highlighted': tag.label === selectedTagLabel }"
                @click.stop="selectTag(tag.label)"
            ) {{ tag.label }}
            span.btn-toogle-tag.btn-nude(
                v-if="fullData.tags.length > 5"
                @click.stop="changeShowAllTagsStatus()") {{ showAllTags ? 'less' : 'more' }}

</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
    props: {
        data: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            showAllTags: false
        }
    },

    computed: {
        // UI
        ...mapState('ui/monitoring', {
            selectedTagLabel: state => state.selectedTagLabel,
            selectedAudienceId: state => state.selectedRowId
        })
    },

    methods: {
        ...mapMutations('ui/monitoring', ['setSelectedTag']),
        selectTag(tagLabel) {
            if (this.selectedTagLabel === null || this.selectedTagLabel !== tagLabel) {
                this.setSelectedTag({ tagLabel })
            } else {
                this.setSelectedTag({ tagLabel: '' })
            }
        },
        changeShowAllTagsStatus() {
            this.showAllTags = !this.showAllTags
        }
    }
}
</script>
